import { VictoryPointDataController } from './VictoryPointDataController.ts';
export class VictoryPointStateReader {
    static totalPublicVictoryPoints(state) {
        let publicVictoryPointsSum = 0;
        for (const [victoryPointType, victoryPointValue] of Object.entries(state)){
            const victoryPointData = VictoryPointDataController.getVictoryPointByType(Number(victoryPointType));
            if (victoryPointData == undefined) continue;
            if (victoryPointData.private) continue;
            publicVictoryPointsSum += victoryPointData.value * victoryPointValue;
        }
        return publicVictoryPointsSum;
    }
    static totalPrivateVictoryPoints(state) {
        let privateVictoryPoints = 0;
        for (const [victoryPointType, victoryPointValue] of Object.entries(state)){
            const victoryPointData = VictoryPointDataController.getVictoryPointByType(Number(victoryPointType));
            if (victoryPointData == undefined) continue;
            privateVictoryPoints += victoryPointData.value * victoryPointValue;
        }
        return privateVictoryPoints;
    }
    static totalVictoryPointsOfType(state, victoryPointTypes) {
        let totalVictoryPoints = 0;
        for (const type of victoryPointTypes){
            if (state[type] == undefined) continue;
            const victoryPointData = VictoryPointDataController.getVictoryPointByType(type);
            if (victoryPointData == undefined) continue;
            var _state_type;
            totalVictoryPoints += ((_state_type = state[type]) !== null && _state_type !== void 0 ? _state_type : 0) * victoryPointData.value;
        }
        return totalVictoryPoints;
    }
}
export class VictoryPointStateWriter {
    static addVictoryPoint(state, victoryPoint) {
        if (state[victoryPoint.victoryPointType] == undefined) state[victoryPoint.victoryPointType] = 0;
        var _state_victoryPoint_victoryPointType;
        state[victoryPoint.victoryPointType] = ((_state_victoryPoint_victoryPointType = state[victoryPoint.victoryPointType]) !== null && _state_victoryPoint_victoryPointType !== void 0 ? _state_victoryPoint_victoryPointType : 0) + 1;
    }
    static removeVictoryPoint(state, victoryPointType) {
        if (state[victoryPointType] == undefined) return false;
        var _state_victoryPointType;
        state[victoryPointType] = ((_state_victoryPointType = state[victoryPointType]) !== null && _state_victoryPointType !== void 0 ? _state_victoryPointType : 0) - 1;
        return true;
    }
}
